// import COMPANY_API from '@/api/masterData/company.js';
export const searchColumns = (ctx) => {
  return [
    {
      prop: 'settlementCompanyNo',
      name: '公司名称',
      type: 'select',
      options: ctx.companyList,
      value: 'personCompanyCode',
      label: 'personCompanyName',
      changeMethod: ctx.changeCompanyHandler,
      // disabled: !ctx.isCreate,
    },
    {
      prop: 'settlementDepartmentNo',
      name: '部门',
      type: 'select',
      disabled: ctx.query?.settlementCompanyNo == '',
      options: ctx.departmentList,
      value: 'personDepartmentCode',
      label: 'personDepartmentName',
      changeMethod: ctx.changeDepartmentHandler,
    },
    // {
    //   prop: 'settlementCompanyNo',
    //   name: '公司名称',
    //   type: 'ajaxSelect',
    //   apiUrl: COMPANY_API.GET_COMPANY_LIST_API,
    //   apiData: {
    //     adminFlag: ctx.userInfo.adminFlag,
    //     tenantCode: ctx.userInfo.tenantCode,
    //   },
    //   clearable: true,
    //   filterable: true,
    //   valueKey: 'companyCode',
    //   labelKey: 'companyName',
    //   changeMethod: 'changeCompanyHandler',
    //   method: 'post',
    // },
    // {
    //   prop: 'settlementDepartmentNo',
    //   name: '部门',
    //   type: 'ajaxSelect',
    //   apiUrl: COMPANY_API.GET_DEPARTMENT_LIST_API,
    //   apiData: {
    //     belongCompanyCode: ctx.companyCode,
    //     tenantCode: ctx.userInfo.tenantCode,
    //   },
    //   clearable: true,
    //   filterable: true,
    //   disabled: !ctx.companyCode,
    //   valueKey: 'createDepartmentCode',
    //   labelKey: 'departmentName',
    //   method: 'post',
    // },
    {
      name: '供应商名称',
      prop: 'supplierNo',
      type: 'searchTableSpec',
      searchType: 'partner',
      extraData: {
        companyCode: ctx.query.settlementCompanyNo,
        departmentCode: ctx.query.settlementDepartmentNo,
        partnerTypes: 'HZHB02,HZHB03,HZHB09,HZHB11,HZHB13',
      },
      isMultiple: true,
      changeMethod: ctx.changeSupplyChainMethod,
    },

    // {
    //   name: '结算中心',
    //   prop: 'settlementCenter',
    //   type: 'select',
    //   options: [
    //     {
    //       label: '中集',
    //       value: '中集',
    //     },
    //     {
    //       label: '柳钢',
    //       value: '柳钢',
    //     },
    //   ],
    // },
    // {
    //   prop: 'settlementCenter',
    //   name: '结算中心',
    //   type: 'ajaxSelect',
    //   apiUrl: COMPANY_API.GET_COMPANY_LIST_API,
    //   apiData: {
    //     adminFlag: ctx.userInfo.adminFlag,
    //     tenantCode: ctx.userInfo.tenantCode,
    //   },
    //   clearable: true,
    //   filterable: true,
    //   valueKey: 'companyCode',
    //   labelKey: 'companyName',
    //   changeMethod: 'changeSettlementCenterHandler',
    //   method: 'post',
    // },
    {
      prop: 'settlementCenter',
      name: '结算中心',
      type: 'select',
      options: ctx.companyList,
      value: 'personCompanyCode',
      label: 'personCompanyName',
      changeMethod: ctx.changeSettlementCenterHandler,
      // disabled: !ctx.isCreate,
    },
    {
      // 申请日期从
      name: '结算日期从',
      prop: 'settlementDateStart',
      type: 'startDaterangePicker',
    },
    {
      // 申请日期到
      name: '结算日期至',
      prop: 'settlementDateEnd',
      type: 'endDaterangePicker',
    },
    {
      name: '原币结算金额(含税)',
      prop: ['originalTotalAmountStart', 'originalTotalAmountEnd'],
      type: 'inputRange',
      precision: 2, //精度，就是保留几位小数,默认两位
      max: 99999999999999.99,
    },
    // {
    //   name: '订单编号',
    //   prop: 'orderNo',
    //   type: 'input',
    // },
    // {
    //   name: '合同编号',
    //   prop: 'contractNo',
    //   type: 'searchTableSpec',
    //   searchType: 'contract',
    //   isMultiple: true,
    //   extraData: {
    //     contractCategory: 'purchase',
    //     contractBusinessCompanyNo: ctx.query.settlementCompanyNo,
    //     contractBusinessDepartment: ctx.query.settlementDepartmentNo,
    //     contractDetailCategory: 'CG01', //制单类型过滤协议的
    //   },
    //   changeMethod: ctx.changeContractMethod,
    // },
    {
      name: '合同编号',
      prop: 'contractNoLike',
      type: 'input',
    },
    {
      name: '订单编号',
      prop: 'orderNoLike',
      type: 'input',
    },
    {
      name: '结算单编号',
      prop: 'payableSettlementNoLike',
      type: 'input',
    },
    {
      name: '结算单状态',
      prop: 'settlementStatus',
      type: 'select',
      options: ctx.dictListMap?.settlementStatus || [],
    },
    {
      name: '付款状态',
      prop: 'paymentStatus',
      type: 'select',
      options: ctx.dictListMap?.pay_paymentStatus || [],
    },
    {
      prop: 'salesmanNo',
      name: '业务员',
      type: 'searchTableSpec',
      searchType: 'personnel',
      isMultiple: true,
      changeMethod: ctx.changeSalesmanNoMethod,
    },
    {
      prop: 'settlementType',
      name: '结算类型',
      type: 'select',
      options: ctx.dictListMap?.settlementType || [],
    },
    {
      name: '已打印',
      prop: 'printFlag',
      type: 'select',
      options: [
        {
          label: '未打印',
          value: '0',
        },
        {
          label: '已打印',
          value: '1',
        },
        {
          label: '全部',
          value: '',
        },
      ],
    },
    {
      name: '业务类别',
      prop: 'settlementBusinessType',
      type: 'select',
      options: ctx.dictListMap?.businessCategoryPayable || [],
    },
  ];
};

// 默认表头
export const defaultTableColumn = (ctx) => [
  {
    type: 'checkbox',
    visible: true,
    width: '50',
    fixed: 'left',
  },
  // {
  //   type: 'seq',
  //   title: 'table.index',
  //   visible: true,
  //   width: '80',
  // },
  {
    field: 'payableSettlementNo',
    title: '结算单编号',
    visible: true,
  },
  {
    field: 'supplierName',
    title: '供应商',
    visible: true,
  },
  {
    field: 'customerName',
    title: '客户名称',
    visible: true,
  },
  ...(ctx.userInfo.businessGroup == '城矿'
    ? [
        {
          field: 'oaUrl',
          title: '审批详情',
        },
      ]
    : []),
  {
    field: 'settlementDepartmentName',
    title: '部门',
    visible: true,
  },
  {
    field: 'settlementCompanyName',
    title: '公司',
    visible: true,
  },
  {
    field: 'settlementBusinessType',
    title: '业务类别',
    visible: true,
  },
  {
    field: 'settlementCenterName',
    title: '结算中心',
    visible: true,
  },
  {
    field: 'settlementDate',
    title: '结算日期',
    visible: true,
  },
  {
    field: 'settlementQuantitySum',
    title: '结算数量',
    visible: true,
  },
  {
    field: 'payunit',
    title: '单位',
    visible: true,
  },
  {
    field: 'originalTotalAmount',
    title: '原币结算总金额(含税)',
    fixed: 'right',
    visible: true,
  },
  {
    field: 'currencyName',
    title: '币种',
    visible: true,
  },
  {
    field: 'exchangeRate',
    title: '汇率',
    visible: true,
  },
  {
    field: 'domesticTotalAmount',
    title: '本币结算总金额(含税)',
    visible: true,
  },
  {
    field: 'payableAccountPeriod',
    title: '应付账期',
    visible: true,
  },
  {
    field: 'settlementType',
    title: '结算类型',
    visible: true,
  },
  // {
  //   field: 'projectInitiationNo',
  //   title: '项目编号',
  //   visible: true,
  // },
  {
    field: 'projectName',
    title: '项目名称',
    visible: true,
  },
  {
    field: 'contractNo',
    title: '合同编号',
    visible: true,
  },
  {
    field: 'orderNo',
    title: '订单编号',
    visible: true,
  },
  {
    field: 'salesmanName',
    title: '业务员',
    visible: true,
  },
  {
    field: 'printFlag',
    title: '是否打印',
    visible: true,
  },
  {
    field: 'paidAmount',
    title: '已付款金额',
    visible: true,
  },
  {
    field: 'unpaidAmount',
    title: '未付款金额',
    visible: true,
  },
  {
    field: 'settlementStatus',
    title: '结算单状态',
    visible: true,
    fixed: 'right',
  },
  {
    field: 'paymentStatus',
    title: '付款状态',
    visible: true,
  },
  // {
  //   field: 'pushJinDieFlag',
  //   title: '推送金蝶信息',
  //   visible: true,
  // },
];

// 默认显示的按钮
export const defaultMenuBtnList = [
  {
    id: 1,
    label: '新增',
    type: '0',
    attributes: {
      buttonUrl: 'add',
    },
  },
  {
    id: 2,
    label: '编辑',
    type: '0',
    attributes: {
      buttonUrl: 'edit',
    },
  },
  {
    id: 3,
    label: '删除',
    type: '0',
    attributes: {
      buttonUrl: 'delete',
    },
  },
  {
    id: 4,
    label: '导出',
    type: '0',
    attributes: {
      // buttonStyle: 'el-icon-remove-outline',
      buttonUrl: 'export',
    },
  },
  {
    id: 5,
    label: '关闭',
    type: '0',
    attributes: {
      buttonUrl: 'close',
    },
  },
  {
    id: 6,
    label: '锁定',
    type: '0',
    attributes: {
      buttonUrl: 'lock',
    },
  },
  {
    id: 7,
    label: '打印',
    type: '0',
    attributes: {
      buttonUrl: 'print',
    },
  },
  // {
  //   id: 8,
  //   label: '推送金蝶',
  //   type: '0',
  //   attributes: {
  //     buttonUrl: 'pushJindie',
  //   },
  // },
  // {
  //   id: 8,
  //   label: '创建结算单',
  //   type: '0',
  //   attributes: {
  //     // buttonStyle: 'el-icon-remove-outline',
  //     buttonUrl: 'create',
  //   },
  // },
];

import BASE_API from '@/api/dataBase';
export default {
  data() {
    return {
      companyList: [],
      departmentList: [],
    };
  },
  methods: {
    // 获取公司
    async _getCompanyApi() {
      console.log('开始获取公司', this.userInfo);
      const { data } = await this.$axios.post(BASE_API.GET_PERSON_API, {
        id: this.userInfo.userCode,
        userCode: this.userInfo.userCode,
        personName: this.userInfo.userName,
      });
      if (data.code == 0) {
        console.log(data.data, '???=====》》');
        this.companyList = data.data?.personCompanyInfo;
        console.log(this.companyList, 'companyList');
        console.log(this.userInfo.companyCode, 'this.userInfo.companyCode');

        // if (!this.userInfo.companyCode) {
        //   const companyCode = data.data.personCompanyInfo
        //     ? data.data.personCompanyInfo[0].companyCode
        //     : null;
        //   const companyName = data.data.personCompanyInfo
        //     ? data.data.personCompanyInfo[0].companyName
        //     : null;
        //   this.query = {
        //     ...this.query,
        //     settlementCompanyNo: companyCode,
        //     settlementCompanyName: companyName,
        //   };
        // } else {
        //   this.query = {
        //     ...this.query,
        //     settlementCompanyNo: this.userInfo.companyCode,
        //     // settlementCompanyName: this.userInfo.companyName,
        //   };
        // }
        // // 供应链运输事业部不默认公司
        // if (this.userInfo.companyCode == 'OAC19') {
        //   if (this.query.settlementCompanyNo) delete this.query.settlementCompanyNo;
        //   if (this.query.settlementCompanyName) delete this.query.settlementCompanyName;
        // } else {
        //   this._getDepartmentByCompanyCodeApi(this.query.settlementCompanyNo, true);
        // }
        setTimeout(() => {
          this.getTableData();
        }, 10);
        // this._getDepartmentByCompanyCodeApi(this.query.settlementCompanyNo, true);
      } else {
        console.error('获取公司失败');
      }
    },
    // 根据公司获取部门
    async _getDepartmentByCompanyCodeApi(companyCode, isFirst = false) {
      console.log(companyCode, isFirst);
      const { data } = await this.$axios.post(BASE_API.GET_PERSON_API, {
        id: this.userInfo.userCode,
        userCode: this.userInfo.userCode,
        personName: this.userInfo.userName,
        personCompanyCode: companyCode,
      });
      if (data.code == 0) {
        console.log(data.data, '部门信息');
        this.departmentList = data.data?.personDepartmentInfo;

        // if (isFirst) {
        //   this.query = {
        //     ...this.query,
        //     settlementDepartmentNo: this.userInfo?.departmentCode,
        //     // settlementDepartmentName: this.userInfo?.departmentName,
        //   };
        //   setTimeout(() => {
        //     this.getTableData();
        //   }, 10);
        // }
      } else {
        console.error('获取部门失败');
      }
    },
    // 切换公司
    changeCompanyHandler(val) {
      console.log(val, '切换公司');
      const item = this.companyList.find((item) => item.personCompanyCode == val);
      console.log(item, '切换公司item');
      this.query = {
        ...this.query,
        settlementDepartmentNo: '',
        // settlementDepartmentName: '',
        settlementCompanyNo: val,
        // settlementCompanyName: item.personCompanyName,
      };
      // 获取部门数据
      this._getDepartmentByCompanyCodeApi(val);
    },
    // 切换部门
    changeDepartmentHandler(val) {
      console.log(val, '切换部门');
      console.log(this.departmentList, 'this.departmentList');

      // const item = this.departmentList.find((item) => item.personDepartmentCode == val);
      this.query = {
        ...this.query,
        settlementDepartmentNo: val,
        // settlementDepartmentName: item.personDepartmentName,
      };
    },
    // 切换结算中心
    changeSettlementCenterHandler(val) {
      console.log(val, '切换结算中心');
      // const item = this.companyList.find((item) => item.personCompanyCode == val);
      this.query = {
        ...this.query,
        settlementCenter: val,
        // settlementCenterName: item.personCompanyName,
      };
    },
  },

  mounted() {
    // this.getCompanyApi();
    this.$nextTick(() => {
      this._getCompanyApi();
    });
  },
};
